<h1 class="c11n-text-xl-headline c11n-space-stack-3x">
    {{ content?.heading }}
</h1>
<c11n-modal-dialog
    #selectUserLevelModalDialog
    (primaryClick)="navigateToForm()"
    [headingText]="content?.wrnSelectUserRequiresForm.heading"
    [hideBody]="true"
    [maxWidth]="660"
    [primaryButtonLabel]="content?.wrnSelectUserRequiresForm.navContinue"
    [secondaryButtonLabel]="content?.wrnSelectUserRequiresForm.navBack"
    [useContentWidth]="false"
    [variant]="'basic'"
    data-cy="">
</c11n-modal-dialog>

<div class="section-width c11n-space-stack-4x">
    <c11n-radio-group
            [formGroup]="usrFormGroup"
            [groupId]="radioGroupId"
            [hideLegend]="true"
            [legendText]="content?.heading"
            [variant]="'tiles'"
    >
        <c11n-radio
                *ngFor="let usr of usrs$ | async"
                [focusLabel]="true"
                [labelText]="constructUserName(usr)">
            <input
                    [formControlName]="selectedUserFormControlName"
                    [name]="selectedUserFormControlName"
                    [value]="usr"
                    c11nRadioInput
                    type="radio"/>
        </c11n-radio>
    </c11n-radio-group>
    <button
            (click)="onAddSomeoneElse()"
            c11n-link
            class="c11n-text-md pointer add-someone-else-button"
            [class.no-existing-users]="(usrs$ | async)?.length === 0"
            data-cy="stepper-add-someone-else-button"
            iconName="plus"
            iconPosition="leading"
            variant="primary-independent">
        {{ content?.navAddSomeoneElse }}
    </button>
    @if (selectedUserFormControl.invalid && selectedUserFormControl.dirty) {
        <div #selectionError
             class="selection-error c11n-space-stack-3x"
             data-cy="selection-error"
             role="alert">
            <c11n-icon [name]="'error'" [size]="'small'"></c11n-icon>
            <strong>Error:</strong> Please select one person from the list or add someone else.
        </div>
    }
</div>

<zci-gaf-complete-our-form-mvp></zci-gaf-complete-our-form-mvp>
